<template>
  <div class="p-5 mb-4 bg-light rounded-3">
    <div class="container-fluid py-3">
      <h1>Vielen Dank!</h1>
      <p class="lead">Ihre Bestellung ist bei uns eingegangen.</p>
      <p>Sie können jetzt Ihre Locations und Mitarbeiter verwalten.</p>
    </div>
  </div>
</template>
